module.exports = __webpack_public_path__ + "img/img7.c3f093c2.png";